module.exports = __webpack_public_path__ + "media/flags/aw-f6ec5a96.svg";